import React from "react";
import { observer } from "mobx-react-lite";

import FormField from "../form-field/FormField";
import { dateService } from "../../services/date-service/DateService";

interface DateCreated {
  date?: Date | string;
}

export default observer(function DisplayDateCreated(props: DateCreated) {
  return (
    <FormField
      id="date-created"
      labelKey="general.date-created"
      readOnly
      fieldValue={props.date ? dateService.formatDate(props.date) : "-"}
    />
  );
});
